<form [formGroup]="form">
  <label translate>dashboard.edit.title</label>
  <input type="text" formControlName="title" class="form-control" />

  <label translate>dashboard.edit.description</label>
  <input type="text" formControlName="description" class="form-control" />
</form>
